import { Affix } from 'antd';
import Sider from 'antd/es/layout/Sider';
import React from 'react';
import classes from './AIAssistanceSider.module.scss'
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setIsOpenAIAssistanceSider } from 'store/slices/aiFunctionsDataSlice';
import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Chat from 'routes/Chat/Chat';

const AIAssistanceSider = () => {
  const { isOpenAIAssistanceSider, assistanceSiderWidth } = useAppSelector((state) => state.aiFunctions);
  const { docsSegment } = useAppSelector((state) => state.windowState);

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  
  const collapseChange = () => {
    if (isOpenAIAssistanceSider) {
      dispatch(setIsOpenAIAssistanceSider({ open: false, width: 0 }));
    } else {
      dispatch(setIsOpenAIAssistanceSider({ open: true, width: 400 }));
    }
  };
  
  return (
    <Affix>
      <Sider
        theme='light'
        width={assistanceSiderWidth || 0}
        collapsedWidth={0}
        collapsed={!isOpenAIAssistanceSider}
        className={classes.assistanceSider}
      >
        <div className={classes.assistanceWrap}>
          <div className={classes.title}>{t('Documents.details.assistanceTab.title')}</div>
          {docsSegment === 'edit' && (
            <div className={classes.collapseBtn} onClick={collapseChange}>
              {isOpenAIAssistanceSider
                ? <div><span>{t('Documents.details.assistanceTab.hide')}</span> <DoubleRightOutlined className={classes.icon} /></div>
                : <div><span>{t('Documents.details.assistanceTab.title')}</span><DoubleLeftOutlined className={classes.icon} /></div>
              }
            </div>
          )}
          <div className={classes.content}>
            <Chat embedded={true} aiAssistant={true}/>
          </div>

        </div>
      </Sider>
    </Affix>
  );
}

export default AIAssistanceSider;
